<div>
  <app-rule-editor-page
    listURL="/rules"
    [practitionerLanguages]="practitionerLanguages"
    [patientLanguages]="patientLanguages"
  ></app-rule-editor-page>
</div>
